import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './i18n'; // i18n init (component'lerden önce yüklenmeli)
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import PwaInstall from './components/PwaInstall';
import LoginPage from './pages/LoginPage';
import MainLayout from './pages/MainLayout';
import DesignPreviewPage from './pages/DesignPreviewPage';
import RfqPublicResponsePage from './pages/RfqPublicResponsePage';
import './styles/global.css';
import './styles/stocks.css';
import './styles/layout.css';
import './styles/ui-components.css';
import './styles/ai-chat.css';
import './styles/mobile.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div className='loading-screen'><div className='loading-spinner'></div></div>;
  if (!isAuthenticated) return <Navigate to='/login' replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <ToastProvider position='top-right'>
        <AuthProvider>
          <Routes>
            <Route path='/login' element={<LoginPage />} />
            <Route path='/design-preview' element={<DesignPreviewPage />} />
            <Route path='/rfq-public/:token' element={<RfqPublicResponsePage />} />
            <Route path='/*' element={<ProtectedRoute><MainLayout /></ProtectedRoute>} />
          </Routes>
          <PwaInstall />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
export default App;
